import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UploadPage from "@/pages/UploadPage";
import AuditPage from "@/pages/AuditPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UploadPage />} />
        <Route path="/audit/:auditId" element={<AuditPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
